import React from 'react';
// import { Img } from 'react-image';
// import { File } from "styled-icons/fa-regular";


// import { File, FilePdf, FileImage } from "styled-icons/fa-regular";

import citycadFileIcon from "../../../assets/images/icons/document_empty.svg";
import urbIcon from "../../../assets/images/icons/urb-doc-48.png";
// import urbResourceIcon from "../../../assets/images/icons/urbresource-doc-48.png";

const getResourceIconFromType = type => {
  if (type === 'application/urb') {
    return (
      <img src={urbIcon} style={{width:"24px"}} alt="URB document icon" />
    )
  }
  // else if (type === 'pdf') {
  //   return (
  //     <FilePdf size={16} />
  //   )
  // }
  // else {
  //   return (
  //     <File size={16} />
  //   )
  // }

  return (
    <img src={citycadFileIcon} alt={`CityCAD file icon`} style={{width:"16px", marginRight:"5px"}}/>
  )
};

export default getResourceIconFromType;
